export const TEST_IDS = {
  APP_TILE: 'app-tile',
  CERTIFICATION_BADGE: 'app-tile__certification-badge',
  RATINGS: 'app-tile__ratings',
  TILE_BADGE: 'app-tile__tile-badge',
  APP_TILE_SKELETON: 'app-tile-skeleton'
};